import * as Icons from "@nova/component-icons"
import { SidePanelLayerType, ToolName } from "@nova/constants"
import { MapComment } from "@nova/protobuf"

import { updateMapComment, deleteMapComment } from "features/pubsub/entityActions/cubes/comments"
import { PluginRegistry } from "plugins/plugin-registry"
import {
    selectAllMapComments,
    selectMapCommentById,
} from "features/entity-caching/map-comments/selectors"
import { zoomToMapComment } from "features/map/inspector-panel/map-comments/module"
import { MapCommentInspectorPanel } from "features/map/inspector-panel/map-comments/MapCommentInspectorPanel"
import { MapCommentPortal } from "./commentPortal"
import { useCommentMapNodes } from "features/map/map-nodes/useCommentMapNodes"
import { getGenericMockableInspectorPanel } from "features/map/inspector-panel/inspector-panels/GenericInspectorPanel"
import { MapCommentList } from "features/map/inspector-panel/map-comments/MapCommentList"
import { CommentDraftMarkerGate } from "./CommentDraftMarker"

export function registerCommentPlugin(registry: PluginRegistry) {
    registry
        .register({
            name: "comments",
            displayName: "Comment",
            sidePanelLayerType: SidePanelLayerType.Comment,
            PrimaryIcon: Icons.ChatBubble,
            updateAction: updateMapComment,
            deleteAction: deleteMapComment,
            confirmDelete: () => false,
            protobufMessage: MapComment,
            selectAllEntities: selectAllMapComments,
            selectSingleEntity: selectMapCommentById,
            zoomTo: zoomToMapComment,
        })
        .implement("inspector-panel-plugin", () => ({
            InspectorPanelComponent: getGenericMockableInspectorPanel({
                // All Comments List
                Mocked: MapCommentList,
                // Individual Comment Panel
                NonMocked: MapCommentInspectorPanel,
            }),
        }))
        .implement("toolbox-plugin", () => ({
            name: ToolName.Comment,
            shortcut: { letters: ["C"] },
            portalComponent: MapCommentPortal,
        }))
        .implement("map-node-plugin", () => ({
            useMapNodes: useCommentMapNodes,
        }))
        .implement("map-modal-plugin", () => ({
            Modal: CommentDraftMarkerGate,
        }))
}
